import axios from 'axios';
export const TERM_SLUG_TO_BLOG_TOPICS_MAPPING = Object.freeze({
    'yocket-prep-gre-blogs': 'gre',
    'yocket-prep-gmat-blogs': 'gmat',
    'yocket-prep-ielts-blogs': 'ielts',
    'yocket-prep-toefl-blogs': 'toefl'
});

export const createSEOMeta = (data) => [
    { hid: 'description', name: 'description', content: data.description },
    { hid: 'og:title', property: 'og:title', content: data.title },
    {
        hid: 'og:description',
        property: 'og:description',
        content: data.description
    },
    {
        hid: 'og:image',
        property: 'og:image',
        content: data.image || 'https://d15gkqt2d16c1n.cloudfront.net/images/yocket_prep_logo.png'
    },
    {
        hid: 'og:url',
        property: 'og:url',
        //   content: process.env.HOST_NAME_DEV + '/' + data.url,
        content: data.url
    },
    {
        hid: 'og:site_name',
        property: 'og:site_name',
        //   content: process.env.HOST_NAME_DEV + '/' + data.url,
        content: 'Yocket Prep'
    },
    {
        hid: 'twitter:card',
        name: 'twitter:card',
        content: data.cardType || 'summary_large_image'
    },
    {
        hid: 'robots',
        name: 'robots',
        content: 'index, dofollow'
    }
];

const sitemapUrl = 'https://prep.yocket.com';
// const allTopics = [
//     '/gre',
//     '/gre/exam-pattern',
//     '/gre/score-chart',
//     '/gre/book-and-resources',
//     '/gre/syllabus',
//     '/gre/eligibility',
//     '/gre/how-to-register',
//     '/gre/exam-dates',
//     '/gre/sample-papers',
//     '/gmat',
//     '/gmat/exam-fees',
//     '/gmat/exam-dates',
//     '/gmat/eligibility-criteria',
//     '/gmat/how-to-register',
//     '/gmat/syllabus',
//     '/gmat/exam-pattern',
//     '/gmat/books-and-resources',
//     '/gmat/sample-papers',
//     '/gmat/score-chart',
//     '/ielts',
//     '/ielts/exam-fees',
//     '/ielts/exam-dates',
//     '/ielts/eligibility-criteria',
//     '/ielts/how-to-register',
//     '/ielts/syllabus',
//     '/ielts/exam-pattern',
//     '/ielts/result-and-scores',
//     '/ielts/books-and-resources',
//     '/ielts/sample-papers',
//     '/toefl',
//     '/toefl/exam-fees',
//     '/toefl/exam-dates',
//     '/toefl/eligibility-criteria',
//     '/toefl/how-to-register',
//     '/toefl/syllabus',
//     '/toefl/exam-pattern',
//     '/toefl/result-and-scores',
//     '/toefl/books-and-resources',
//     '/toefl/sample-papers'
// ];

const excludedUrls = [
    '/profile',
    '/dashboard',
    '/priority-planner/plan',
    '/latex-testing',
    '/gre/quick-diagnostic',
    '/gre-calculator',
    '/gre-to-gmat-calculator',
    '/gre-score-calculator',
    '/gmat-score-calculator',
    '/all-india-gre-test'
];

export const fetchAllGuideRoutes = async () => {
    const allGuideUrls = [];

    try {
        const {
            data: {
                data: { results: guideTabs }
            }
        } = await axios.get(`${process.env.CMS_API}/v1/seo/guides/exam`, {
            params: { is_published: true },
            headers: { 'x-source-app': 'supertest' }
        });

        guideTabs.forEach((tab) => {
            if (tab.is_published && tab.guide_pages?.length) {
                tab.guide_pages.forEach((page) => {
                    const slug = page.slug;
                    const route = slug === tab.slug ? `/${slug}` : `/${tab.slug}/${slug}`;
                    allGuideUrls.push(route);
                });
            }
        });

        return allGuideUrls;
    } catch (error) {
        console.error('Error fetching guide routes:', error);
        return [];
    }
};

const fetchAllBlogRoutes = async () => {
    try {
        const {
            data: { data }
        } = await axios.get(`${process.env.BACKEND_API}/v2/articles/sitemap`);

        const blogRoutes = data.map((blog) => {
            return {
                url: `/${TERM_SLUG_TO_BLOG_TOPICS_MAPPING[blog.term_slug]}/${blog.slug}`,
                lastmod: blog.updated_at
            };
        });

        return blogRoutes;
    } catch (error) {
        console.error('Error fetching blog routes:', error);
        return [];
    }
};

export const createSitemap = () => {
    return [
        {
            hostname: sitemapUrl,
            path: '/sitemap.xml',
            defaults: {
                changefreq: 'weekly',
                priority: 0.9,
                lastmod: new Date()
            },
            exclude: excludedUrls,
            routes: async () => {
                try {
                    const allGuideUrls = await fetchAllGuideRoutes();
                    const blogRoutes = await fetchAllBlogRoutes();
                    return [...allGuideUrls, ...blogRoutes];
                } catch (error) {
                    console.error('Error generating sitemap:', error);
                    return [];
                }
            }
        }
    ];
};

export const createRobots = () => {
    const sitemapUrls = [`${sitemapUrl}/sitemap.xml`];

    return {
        UserAgent: '*',
        Disallow: process.env.SERVER_ENV === 'prod' ? excludedUrls : '/',
        Sitemap: process.env.SERVER_ENV === 'prod' ? sitemapUrls : []
    };
};
